import {
    Alert
} from 'reactstrap';
import React from 'react';
import { withApiData, ApiDataBinding } from 'react-api-data';
import { compose } from 'recompose';
import { withTranslation, WithTranslation } from 'react-i18next';

// constants
import { NetworkRequestStatus, Roles } from 'constants/literals';

// components
import BaseFormModal, { BaseFormModalProps } from './BaseFormModal';
import { BaseModalTemplate, FormModalButtons } from './BaseModalTemplate';
import RolesChecker from 'components/utils/RolesChecker';
import { LinkVlanExternalAttribute, ReactApiDataActions } from 'constants/api';

interface InputProps {
    linkVlanExternalAttributeUuid: string;
    linkVlanUuid: string;
}

interface EnhanceProps {
    deleteLinkVlanExternalAttribute: ApiDataBinding<{ data: LinkVlanExternalAttribute }>;
    apiDataActions: ReactApiDataActions;
}

type Props = EnhanceProps & InputProps & WithTranslation & BaseFormModalProps;

const enhance = compose<EnhanceProps & WithTranslation, InputProps>(
    withApiData(
        {
            deleteLinkVlanExternalAttribute: 'deleteLinkVlanExternalAttribute'
        }
    ),
    withTranslation()
);

class LinkVlanExternalAttributeDeleteModal extends BaseFormModal<Props> {
    componentDidUpdate(prevProps: Readonly<Props>): void {
        const { deleteLinkVlanExternalAttribute, t } = this.props;
        this.handleFormSubmission(prevProps.deleteLinkVlanExternalAttribute.request, deleteLinkVlanExternalAttribute.request, {
            successMessage: t('linkVlanExternalAttributes.deleteSuccessMessage')
        });
    }

    _handleSubmit = () => {
        const { linkVlanExternalAttributeUuid, apiDataActions, linkVlanUuid, deleteLinkVlanExternalAttribute } = this.props;
        deleteLinkVlanExternalAttribute.perform(
            {
                uuid: linkVlanExternalAttributeUuid
            }
        ).then((response) => {
            if (response.request.networkStatus === NetworkRequestStatus.Success) {
                apiDataActions.invalidateCache('getLinkVlan', { linkVlanUuid });
                apiDataActions.invalidateCache('getLinkVlanExternalAttributes');
            }
        });
    }

    render() {
        const { t } = this.props;

        return (
            <React.Fragment>
                <BaseModalTemplate
                    isOpen={this.state.isOpen}
                    toggle={this.toggle}
                    header={t('linkVlanExternalAttributes.deleteModalTitle')}
                    body={
                        <Alert color="warning" className="mb-0">
                            <strong>{t('common.warning')}</strong>
                            <p>{t('linkVlanExternalAttributes.deleteWarningMessage')}</p>
                        </Alert>
                    }
                    footer={
                        <FormModalButtons
                            loading={false}
                            toggle={this.toggle}
                            onSubmit={this._handleSubmit}
                        />
                    }
                />
                <RolesChecker data-test="user-roles-checker" roles={[Roles.admin, Roles.noc]}>
                    <span data-test="linkVlan-attribute-delete-btn" className="fas fa-trash fa-pull-left mt-1 text-primary cursor-pointer" 
                          onClick={this.toggle} title={t('linkVlanExternalAttributes.deleteModalTitle')}>
                    </span>
                </RolesChecker>
            </React.Fragment>
        );
    }
}

export default enhance(LinkVlanExternalAttributeDeleteModal);
